import React from 'react';
import { AppRouteProps } from '@bsm/component'
import { StudentCreationRoutes } from './views/create/StudentCreationRoutes'
import { StudentListRoutes } from './views/list/StudentListRoutes'
import { StudentDetailsRoutes } from './views/details/StudentDetailsRoutes';
import { AdmissionListRoutes } from 'views/admission-list/AdmissionListRoutes';
import StudentCreationContainer from 'views/create/containers/StudentCreationContainer';
const StudentsContainer = React.lazy(() => import('./container/StudentsContainer'));
const AdmissionsContainer = React.lazy(() => import('./container/AdmissionsContainer'));

export const StudentsRoutes: Array<AppRouteProps> = [
    {
        path: "students",
        element: <StudentsContainer />,
        children: [
            ...StudentListRoutes,
            ...StudentCreationRoutes,
            ...StudentDetailsRoutes,
        ],
    },
    {
        path: "admissions",
        element: <AdmissionsContainer />,
        children: [
            ...AdmissionListRoutes,
            {
                path: 'create',
                element: <StudentCreationContainer />,
                children: []
            }
        ],
    },
];
